export enum RenderStage {
  Preview = 'preview',
  Publish = 'publish',
}
